import { render, staticRenderFns } from "./RightMain.vue?vue&type=template&id=4dc9bf2e"
import script from "./RightMain.vue?vue&type=script&lang=js"
export * from "./RightMain.vue?vue&type=script&lang=js"
import style0 from "./RightMain.vue?vue&type=style&index=0&id=4dc9bf2e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports